export default __webpack_public_path__ + "static/media/hostfully_step1.31ab7884.png";